import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/email/outbox';

export default {

    getEmailOutbox(webId, to, cc, bcc, responseStatus, dateFrom, dateTo, page, size, sort) {
        const params = {
            'to': to,
            'cc': cc,
            'bcc': bcc,
            'responseStatus': responseStatus,
            'dateFrom': dateFrom,
            'dateTo': dateTo,
            'page': page,
            'size': size,
            'sort': sort
        }
        return axios.get(BASE_URL + '/' + webId + '/statistic', {params: params});
    }
}